import { render, staticRenderFns } from "./DrugStoreDetails.vue?vue&type=template&id=4011677d&scoped=true&lang=pug&"
import script from "./DrugStoreDetails.vue?vue&type=script&lang=ts&"
export * from "./DrugStoreDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DrugStoreDetails.vue?vue&type=style&index=0&id=4011677d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011677d",
  null
  
)

export default component.exports